jQuery( $ => {
	if ( $( '.ps-case-listing' )[ 0 ] ) { // check if filter is needed on page
		$( '.ps-case-listing li' ).on( 'click', function() {
			const filterSelect = $( this ).attr( 'class' );

			$( '.ps-case-listing li' ).removeClass( 'active' );
			$( this ).addClass( 'active' );

			if ( 'ps-case-listing-unlisted' === filterSelect ) {
				$( '.transactions-item.listed' ).hide( 300 );
				$( '.transactions-item.not-listed' ).show( 300 );
			} else if ( 'ps-case-listing-listed' === filterSelect ) {
				$( '.transactions-item.not-listed' ).hide( 300 );
				$( '.transactions-item.listed' ).show( 300 );
			} else {
				$( '.transactions-item' ).show( 300 );
			}
		} );
	}
} );
